import horizontalBarchart from './horizontalBarchart';
import verticalBarchart from './verticalBarchart';
import scatterplot from './scatterplot';
import scatterplotImage from './scatterplotImage';
import lineChart from './lineChart';
import multiLineChart from './multiLineChart';
import pie from './pie';
import comboLineBarchart from './comboLineBarchart';
import stackedBarchart from './stackedBarchart';
import verticalRangeGauge from './verticalRangeGauge';
import verticalGauge from './verticalGauge';
import verticalGroupBarchart from './verticalGroupBarchart';
import rangeArea from './rangeArea';
import gantt from './gantt';
import merimekko from './merimekko';
import pointDistribution from './pointDistribution';
import pyramid from './pyramid';

export default {
  horizontalBarchart,
  verticalBarchart,
  scatterplot,
  scatterplotImage,
  lineChart,
  multiLineChart,
  pie,
  comboLineBarchart,
  stackedBarchart,
  verticalRangeGauge,
  verticalGauge,
  verticalGroupBarchart,
  rangeArea,
  gantt,
  merimekko,
  pointDistribution,
  pyramid,
};
